export const START_PAGE_NUMBER = 1;

export const LABELS_FOR_TAB = [
  'Sharing',
  'Gradebook',
  'Learning progress',
  'Learning report',
];

const [SHARING, GRADEBOOK, LEARNING_PROGRESS, LEARNING_REPORT] = LABELS_FOR_TAB;

export const TAB_NAMES = {
  SHARING,
  GRADEBOOK,
  LEARNING_PROGRESS,
  LEARNING_REPORT,
};

export const URL_PARAMS_SEQUENCE = {
  page: 1,
  signature: 2,
  tab: 3,
  module: 4,
  chapter: 5,
  pill: 6,
  material: 7,
};
export const GITHUB_ACCOUNT_LINKED_PREFIX = 'github_account_linked';
export const GITHUB_ACCOUNT_LINKED = `#${GITHUB_ACCOUNT_LINKED_PREFIX}`;
